import React, { Component } from 'react'
import { Modal, Button } from 'hljd'
import { observer } from 'mobx-react'
import styles from './style.module.less'
@observer
export default class extends Component {
  render() {
    const {
      protocolModalVisible,
      liveProtocol,
      cancelModal,
      agreeProtocol
    } = this.props.store
    const { protocol_title, protocol_content } = liveProtocol
    return (
      <Modal
        wrapClassName={styles.protocolModal}
        width={526}
        visible={protocolModalVisible}
        onCancel={cancelModal('protocolModalVisible')}
        title={protocol_title}
        footer={[
          <Button key="submit" type="primary" onClick={agreeProtocol}>
            我同意遵守协议并继续下单
          </Button>
        ]}
      >
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: protocol_content }}
        />
      </Modal>
    )
  }
}
